// Dados societários usados nas páginas legais (Termos e Privacidade).
// Campos "[a completar]" aguardam confirmação com o jurídico — preencha aqui, em um único lugar.
export const EMPRESA = {
  razaoSocial: 'UpdateCommit Tecnologia Ltda',
  cnpj: '[a completar]',
  endereco: 'R. Visconde de Pirajá, 414 - Sala 718, Ipanema, Rio de Janeiro - RJ',
  foro: 'Comarca da Capital do Estado do Rio de Janeiro',
  emailContato: 'contato@updatecommit.com',
  emailPrivacidade: 'contato@updatecommit.com',
  dpo: '[a completar]',
};
